import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { BehaviorSubject, of } from 'rxjs';
import { delay, first, tap } from 'rxjs/operators';

@Component({
  selector: 'studio-clipboard-copy',
  templateUrl: './clipboard-copy.component.html',
  styleUrls: ['./clipboard-copy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClipboardCopyComponent {
  @Input() copyText = '';
  @Output() copied = new EventEmitter<string>();
  @Input() successMessage = 'Copied to clipboard!';
  @Input() failureMessage = 'Copy to clipboard failed, please try again later';

  isCopied$ = new BehaviorSubject(false);

  constructor(private clipboard: Clipboard, private snackBar: MatSnackBar) {}

  copyValue() {
    if (!this.isCopied$.value) {
      this.isCopied$.next(true);
      const copied = this.clipboard.copy(this.copyText);

      if (copied) {
        this.copied.emit(this.copyText);
        this.snackBar.open(this.successMessage, 'Dismiss');
      } else {
        this.snackBar.open(this.failureMessage, 'Dismiss');
      }

      of(false)
        .pipe(
          delay(1500),
          first(),
          tap(() => {
            this.isCopied$.next(false);
          }),
        )
        .subscribe();
    }
  }
}
